import {Component, Input, OnInit} from '@angular/core';
import {Dad, DadSubscriberData} from '../../../models/dad';
import {AuthenticationService} from '../../../../authenticationModule/services/authentication.service';
import {DadService} from '../../../services/dad.service';
import {ControlContainer, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {formatDate} from '@angular/common';

@Component({
  selector: 'app-confirmation-section',
  templateUrl: './confirmation-section.component.html',
  styleUrls: ['./confirmation-section.component.scss']
})
export class ConfirmationSectionComponent implements OnInit {

  @Input() currentDad: Dad;
  @Input() previousMonthSubscriptionData: DadSubscriberData;
  @Input() scheduleNumber: number;
  @Input() originalClientDeclarationMode = false;
  public dadDeclarationForm: UntypedFormGroup;

  constructor(
    private controlContainer: ControlContainer,
    private authService: AuthenticationService,
    private dadService: DadService
  ) {
  }

  ngOnInit() {
    return this.addFormController();
  }

  private addFormController() {
    this.dadDeclarationForm = <UntypedFormGroup>this.controlContainer.control;
    this.dadDeclarationForm.addControl('ipAddress', new UntypedFormControl({
      value: '',
      disabled: true
    }));
    this.setIpAddressControlValue();
    this.dadDeclarationForm.addControl('editedBy', new UntypedFormControl({
      value: this.editedBy,
      disabled: !this.isMckayUser
    }));
    this.dadDeclarationForm.addControl('email', new UntypedFormControl({
      value: this.getEmailControlValue(),
      disabled: true
    }));
    this.dadDeclarationForm.addControl('dateReported', new UntypedFormControl({
      value: this.getDateReportedControlValue(),
      disabled: true
    }));
    this.dadDeclarationForm.addControl('mckayComment', new UntypedFormControl(this.currentDad.mckayComment));
    this.dadDeclarationForm.addControl('printName', new UntypedFormControl(this.printName, this.isMckayUser ? [] : [Validators.required]));
    this.dadDeclarationForm.addControl('editedAt', new UntypedFormControl({
      value: this.getEditedAtControlValue(),
      disabled: true
    }));
    if (this.currentDad.dadConfig.canAutoReport) {
      this.dadDeclarationForm.addControl('autoReport', new UntypedFormControl(this.currentDad.autoReport));
    }
    if (this.originalClientDeclarationMode) {
      this.dadDeclarationForm.disable();
    }
  }

  private getDateReportedControlValue() {
    if (this.currentDad.decodedSubscriberData) {
      return formatDate(new Date(this.currentDad.completedDate), 'yyyy-MM-dd', 'en-US');
    }
    if (this.isMckayUser) {
      return '';
    }
    return formatDate(new Date(), 'yyyy-MM-dd', 'en-US');
  }

  private getEditedAtControlValue() {
    return this.currentDad.editedAt ?
      formatDate(new Date(this.currentDad.editedAt), 'yyyy-MM-dd', 'en-US') :
      formatDate(new Date(), 'yyyy-MM-dd', 'en-US');
  }

  private getEmailControlValue() {
    if (this.currentDad.decodedSubscriberData && this.currentDad.decodedSubscriberData.email) {
      return this.currentDad.decodedSubscriberData.email;
    }
    if (this.isMckayUser) {
      return '';
    }
    return this.loggedInUserEmail;
  }

  private setIpAddressControlValue() {
    if (this.isMckayUser) {
      this.dadDeclarationForm.get('ipAddress').setValue(this.currentDad.decodedSubscriberData ? this.currentDad.decodedSubscriberData.ip_address : '');
      return;
    }
    if (this.currentDad.decodedSubscriberData && this.currentDad.decodedSubscriberData.ip_address !== '') {
      this.dadDeclarationForm.get('ipAddress').setValue(this.currentDad.decodedSubscriberData.ip_address);
      return;
    }
    this.dadService.getClientIp().subscribe(res => {
      this.dadDeclarationForm.get('ipAddress').setValue(res[0]);
    });
  }

  get loggedInUserEmail() {
    return this.authService.userCurrent.email;
  }

  get isMckayUser() {
    return this.authService.userCurrent.permissions.isMckayUser;
  }

  canAutoReport() {
    if (!this.currentDad) {
      return;
    }
    return this.currentDad.dadConfig.canAutoReport;
  }

  get printName(): string {
    if (this.currentDad.decodedSubscriberData && this.currentDad.decodedSubscriberData.print_name) {
      return this.currentDad.decodedSubscriberData.print_name;
    }
    if (!this.currentDad.decodedSubscriberData
      && this.previousMonthSubscriptionData
      && this.previousMonthSubscriptionData.print_name
      && this.previousMonthSubscriptionData.print_name !== 'carry forward'
    ) {
      return this.previousMonthSubscriptionData.print_name;
    }

    return '';
  }

  get editedBy(): string {
    if (this.currentDad.editedBy) {
      return this.currentDad.editedBy;
    }
    if (!this.isMckayUser) {
      return '';
    }
    if (this.printName) {
      return this.authService.userCurrent.name + ' reporting on behalf of ' + this.printName;
    }

    return this.authService.userCurrent.name;
  }
}
